import React from "react";
import { useTranslation } from "react-i18next";
import LegalDocumentView, { LegalSection } from "./LegalDocumentView";

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      title: t("legal.terms.sections.general.title"),
      subsections: t("legal.terms.sections.general.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
        bullets?: string[];
      }>,
    },
    {
      title: t("legal.terms.sections.responsibilities.title"),
      subsections: t("legal.terms.sections.responsibilities.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.serviceDelivery.title"),
      subsections: t("legal.terms.sections.serviceDelivery.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
        bullets?: string[];
        subsections?: Array<{
          number: string;
          text: string;
        }>;
      }>,
    },
    {
      title: t("legal.terms.sections.subscriptionAccount.title"),
      subsections: t("legal.terms.sections.subscriptionAccount.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.subscriptionFee.title"),
      subsections: t("legal.terms.sections.subscriptionFee.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean }>;
        bullets?: string[];
      }>,
    },
    {
      title: t("legal.terms.sections.intellectualProperty.title"),
      subsections: t("legal.terms.sections.intellectualProperty.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.externalMedia.title"),
      subsections: t("legal.terms.sections.externalMedia.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
        bullets?: string[];
        tailParagraphs?: Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
        subsections?: Array<{
          number: string;
          text: string | Array<string | { text: string; strong?: boolean; linkUrl?: string }>;
        }>;
      }>,
    },
    {
      title: t("legal.terms.sections.dataProtection.title"),
      subsections: t("legal.terms.sections.dataProtection.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.termination.title"),
      subsections: t("legal.terms.sections.termination.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.rightToCancel.title"),
      subsections: t("legal.terms.sections.rightToCancel.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.limitationsOfLiability.title"),
      subsections: t("legal.terms.sections.limitationsOfLiability.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.indemnification.title"),
      subsections: t("legal.terms.sections.indemnification.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.forceMajeure.title"),
      subsections: t("legal.terms.sections.forceMajeure.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.changes.title"),
      subsections: t("legal.terms.sections.changes.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.contacts.title"),
      subsections: t("legal.terms.sections.contacts.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.otherProvisions.title"),
      subsections: t("legal.terms.sections.otherProvisions.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
    {
      title: t("legal.terms.sections.governingLaw.title"),
      subsections: t("legal.terms.sections.governingLaw.subsections", {
        returnObjects: true,
      }) as Array<{
        number: string;
        text: string;
      }>,
    },
  ];

  return (
    <div className="space-y-6">
      <header className="border-b border-slate-200 pb-6">
        <h2 className="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">
          {t("legal.terms.title")}
        </h2>
        <p className="mt-3 text-base font-medium text-blue-700">
          {t("legal.terms.subtitle")}
        </p>
        <p className="mt-4 max-w-4xl text-base leading-8 text-slate-700 md:text-lg">
          {t("legal.terms.description")}
        </p>
      </header>

      <LegalDocumentView sections={sections} />
    </div>
  );
};

export default TermsAndConditions;
